import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import previewTable from 'api/DatasetTable/previewTable';

export default function useTablePreview() {
    const params = useParams();
    const { openAlert } = useAlert();
    const client = useClient();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [tableHeaders, setTableHeaders] = useState([]);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                if (params.uri) {
                    const response = await client.query(
                        previewTable(params.uri),
                    );
                    if (!response.errors) {
                        const tableHeaders =
                            response.data.previewTable.fields.map(
                                (item: string) => {
                                    return {
                                        header: item,
                                        key: item,
                                    };
                                },
                            );
                        setTableHeaders(tableHeaders);
                        setRows(response.data.previewTable.rows);
                    } else {
                        openAlert({
                            message:
                                response.errors[0]?.message ??
                                'Failed to preview table',
                            severity: 'alert',
                        });
                        setError(true);
                    }
                }
            } finally {
                setLoading(false);
            }
        };

        if (client) {
            fetchData();
        }
    }, [client, params.uri]);

    return { tableHeaders, rows, loading, error };
}
